import { COURSES_MODES } from '@yandex-int/k-common/constants';
import { createSelector } from 'reselect';

import { getCoursesByClassAndSubject, getPrevYearCoursesWithFinishedLessons } from 'store/courses/selectors';
import { getCurrentYearCourseUtil } from 'utils/get-course';

export const getJournalCourses = createSelector([getCoursesByClassAndSubject], (courses) =>
    courses ? courses.filter(({ mode }) => mode === COURSES_MODES.USUAL) : courses
);

export const getCoursesWithLessons = createSelector(
    [getCoursesByClassAndSubject, getPrevYearCoursesWithFinishedLessons],
    (courses, prevYearCourses) => {
        const currentCourse = getCurrentYearCourseUtil(courses);
        const prevYearFilteredCourses = prevYearCourses
            ? prevYearCourses.filter(({ mode }) => mode === COURSES_MODES.USUAL)
            : prevYearCourses;

        return currentCourse ? [currentCourse, ...prevYearFilteredCourses] : prevYearCourses;
    }
);
